<pr-icon
  [name]="name || 'sp-question-mark'"
  class="pointer"
  [viewBoxWidth]="viewBoxWidth"
  [viewBoxHeight]="viewBoxHeight"
  [width]="width"
  [tooltip]="myTooltip"
></pr-icon>

<ng-template #myTooltip [animation]="true" placement="left">
  @if (tooltipIcon) {
    <pr-icon
      [name]="tooltipIcon"
      [viewBoxWidth]="viewBoxWidth"
      [viewBoxHeight]="viewBoxHeight"
      [width]="width"
      [tooltip]="myTooltip"
      container="body"
    ></pr-icon>
  }
  <span>{{ tooltip }}</span>
</ng-template>
